// import { Predicate } from '@angular/core';
// import { Update, EntityMapOne, EntityMap } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { IPlaatoStatus } from 'app/models/plaato-status';
import { PlaatoMessage, SignalRConnectionState } from 'app/models/plaato-message.model';

export const setItem = createAction('[App Component] Set selected id', props<{ id: string }>());

export const addItem = createAction('[App Component] Add Plaato Status', props<{ item: IPlaatoStatus }>());
export const upsertItem = createAction('[App Component] Upsert Plaato Status', props<{ item: IPlaatoStatus }>());
export const deleteItem = createAction('[App Component] Delete Plaato Status', props<{ id: string }>());

// Realtime Actions
export const startConnection = createAction('[Plaato Realtime] Start Connection');
export const stopConnection = createAction('[Plaato Realtime] Stop Connection');
export const subscribeToDevice = createAction('[Plaato Realtime] Subscribe to Device', props<{ deviceId: string }>());
export const unsubscribeFromDevice = createAction('[Plaato Realtime] Unsubscribe from Device', props<{ deviceId: string }>());

export const connectionStateChanged = createAction('[Plaato Realtime] Connection State Changed', props<{ state: SignalRConnectionState }>());
export const messageReceived = createAction('[Plaato Realtime] Message Received', props<{ deviceId: string, message: PlaatoMessage }>());
export const historyReceived = createAction('[Plaato Realtime] History Received', props<{ deviceId: string, history: PlaatoMessage[] }>());
export const deviceListReceived = createAction('[Plaato Realtime] Device List Received', props<{ devices: string[] }>());
export const errorOccurred = createAction('[Plaato Realtime] Error Occurred', props<{ error: string }>());


